<template>
  <v-navigation-drawer
    class="nav-drawer"
    :class="{rounded}"
    color="primary"
    dark
    permanent
    :mini-variant="!expanded"
    :value="expanded"
    :fixed="!absolute"
    :absolute="absolute"
  >
    <div
      class="nav-container"
      :class="{'space-between-options': spaceBetweenOptions}"
    >
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <v-img
              v-if="!hideLogo"
              class="logo-img"
              :src="logo"
              @click="$emit('click:logo')"
            ></v-img>
          </v-list-item-avatar>
        </v-list-item>
      </v-list>

      <v-list class="menu-options-list" nav dense>
        <v-list-item
          v-for="(menuOption, index) of menuOptions"
          :key="index"
          link
          @click="$emit('click', menuOption)"
        >
          <v-list-item-icon>
            <v-icon>{{ menuOption.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ menuOption.title }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-list class="footer-options-list" nav dense>
        <v-list-item
          v-for="(menuOption, index) of footerOptions"
          :key="index"
          link
          @click="$emit('footer', menuOption)"
        >
          <v-list-item-icon>
            <v-icon>{{ menuOption.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ menuOption.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    menuOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    footerOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    hideLogo: {
      type: Boolean,
      default: false,
    },
    logo: {
      type: String,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    absolute: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    spaceBetweenOptions: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-drawer {
  background: var(--primary);

  &.rounded {
    border-radius: 0px 20px 20px 0px !important;
  }
}

.logo-img {
  cursor: pointer;
}

.nav-container {
  display: grid;
  height: 100%;
  grid-template-rows: auto 1fr auto;

  &.space-between-options {
    align-items: center;
  }
}
</style>
